"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MEDIA_PROPERTIES = exports.MEDIA_EVENTS = exports.KEYWORDS_TAB = exports.GROUPS_TAB = exports.DETECTOR_COLORS = exports.DETECTION_TAB = exports.COLORS = exports.CLASSIFIER_TAB = void 0;
var COLORS = ['#55a01a', '#9932cc', '#ff69b4', '#6495ed', '#ffd700', '#f6a7a1', '#7fb397', '#009999'];
exports.COLORS = COLORS;
var DETECTOR_COLORS = ['#AEDBFC', '#D5BBF4', '#CBECA9', '#F5BDD8', '#F4B4AF', '#FBE59B', '#F5BE9C'];
exports.DETECTOR_COLORS = DETECTOR_COLORS;
var MEDIA_EVENTS = ['abort', 'canplay', 'canplaythrough', 'durationchange', 'emptied', 'ended', 'error', 'loadeddata', 'loadedmetadata', 'loadstart', 'pause', 'play', 'playing', 'progress', 'ratechange', 'seeked', 'seeking', 'stalled', 'suspend', 'timeupdate', 'volumechange', 'waiting', 'speedchange'];
exports.MEDIA_EVENTS = MEDIA_EVENTS;
var MEDIA_PROPERTIES = ['audioTracks', 'autoplay', 'buffered', 'controller', 'controls', 'crossOrigin', 'currentSrc', 'currentTime', 'defaultMuted', 'defaultPlaybackRate', 'duration', 'ended', 'error', 'loop', 'mediaGroup', 'muted', 'networkState', 'paused', 'playbackRate', 'played', 'preload', 'readyState', 'seekable', 'seeking', 'src', 'startDate', 'textTracks', 'videoTracks', 'volume', 'playbackRate'];
exports.MEDIA_PROPERTIES = MEDIA_PROPERTIES;
var KEYWORDS_TAB = 1;
exports.KEYWORDS_TAB = KEYWORDS_TAB;
var DETECTION_TAB = 2;
exports.DETECTION_TAB = DETECTION_TAB;
var CLASSIFIER_TAB = 3;
exports.CLASSIFIER_TAB = CLASSIFIER_TAB;
var GROUPS_TAB = 4;
exports.GROUPS_TAB = GROUPS_TAB;